export default "__VITE_ASSET__wwqbeKYy__"